import { render, staticRenderFns } from "./AccountOption.vue?vue&type=template&id=63aa0ac3&scoped=true"
import script from "./AccountOption.vue?vue&type=script&lang=js"
export * from "./AccountOption.vue?vue&type=script&lang=js"
import style0 from "./AccountOption.vue?vue&type=style&index=0&id=63aa0ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa0ac3",
  null
  
)

export default component.exports